import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { CustomerListApi } from "./api";

interface customerListSliceState {
  customerList: any;
  loadingState?: string;
  errorMessage?: string;
}
const initialCustomerList: any = [];
const initialState: customerListSliceState = {
  customerList: initialCustomerList,
  loadingState: undefined,
  errorMessage: undefined,
};

export const fetchPSTCustomerList = createAsyncThunk<any>(
  "pstCustomerList/fetchPSTCustomerList",
  async () => {
    const response = await CustomerListApi.getPSTCustomerList();
    return response.result;
  }
);
const pstCustomerListSlice = createSlice({
  name: "pstCustomerList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPSTCustomerList.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        pstCustomerList: [...action.payload],
      };
    });
    builder.addCase(fetchPSTCustomerList.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "error",
      };
    });
    builder.addCase(fetchPSTCustomerList.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
  },
});
export const getPSTCustomerListSelector = (state: RootState) =>
  state.pstCustomerList.pstCustomerList;

export const loadingPSTCustomerListSelector = (state: RootState) =>
  state.pstCustomerList.loadingState;
export default pstCustomerListSlice.reducer;
